import _keyBy from 'lodash/keyBy';

import { Folder } from 'shared/models/folder';

function flattenFolders(mainFolder: Folder) {
  const flattenedFolders: Folder[] = [mainFolder];

  for (let folder of mainFolder.Folders) {
    flattenedFolders.push(...flattenFolders(folder));
  }

  return flattenedFolders;
}

export default function replaceFolderChain(
  foldersChain: Folder[],
  rootFolder: Folder
) {
  const flattenedFolders = flattenFolders(rootFolder);
  const foldersDictionary = _keyBy(flattenedFolders, 'Id');

  const newFoldersChain: Folder[] = [];

  for (let folder of foldersChain) {
    const newFolder = (foldersDictionary[folder.Id] ?? null) as Folder | null;

    if (!newFolder) {
      newFoldersChain.push({ ...rootFolder });
      break;
    }

    newFoldersChain.push({ ...newFolder });
  }

  return newFoldersChain;
}
